import { CanActivateFn, Router, UrlTree } from '@angular/router'; 
import { AuthService } from '@org/shared-services';
import { inject } from '@angular/core';
import { of, Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

export const noAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Only check synchronously if user info is already loaded
  if (authService.currentUserValue !== null) {
    return of(checkNoAuth(authService, router));
  }

  // Otherwise, fetch current user from backend
  return authService.getCurrentUser().pipe(
    take(1),
    switchMap(() => of(checkNoAuth(authService, router)))
  );
};

function checkNoAuth(authService: AuthService, router: Router): boolean | UrlTree {
  if (authService.isLoggedIn() && authService.hasRole("tech")) {
    return router.createUrlTree(['/mobile/new-task']);
  } else if (authService.isLoggedIn()) {
    return router.createUrlTree(['/dashboard']);
  } else {
    return true;
  }
}


